import React, { useEffect, useState } from "react";
import Modal from "../../Modal";
import { toPng } from "html-to-image";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
const PurchaseDetailModal = ({ setUpdateState, data }) => {
  const [paidAmount, setPaidAmount] = useState("");
  const [discountedAmount, setDiscountedAmount] = useState("");
  const handleClose = () => {
    setUpdateState((prev) => ({
      ...prev,
      purchaseModal: false,
    }));
  };
  useEffect(() => {
    const discount = data?.discount?.split("%")?.[0];
    const priceDiscounted = (data?.price * discount) / 100;
    const amount = data?.price - (data?.price * discount) / 100;
    setPaidAmount(amount);
    console.log({ priceDiscounted });
    
    setDiscountedAmount(priceDiscounted);
  }, []);
  const SaveAsPDFHandler = () => {
    const doc = new jsPDF();

    // Title for the PDF
    doc.setFontSize(18);
    doc.text("Purchase Invoice", 14, 20);

    // Extract table data
    const table = document.querySelector("#print table");
    const rows = Array.from(table.rows).map((row) =>
      Array.from(row.cells).map((cell) => cell.innerText)
    );

    // Add the table to the PDF
    doc.autoTable({
      startY: 30,
      body: rows.slice(1), // Skip the header if there's any
      head: [rows[0]], // Use the first row as the header
    });

    // Save the PDF
    doc.save("Purchase_Invoice.pdf");
  };
  return (
    <Modal>
      <div className="modal-body">
        <div className="Category">
          <a className="CloseModal" onClick={handleClose}>
            ×
          </a>
          <h3>Purchase Details</h3>
          <div className="PurchaseDetailsTable" id="print">
            <table>
              <tbody>
                <tr>
                  <td>Date of Purchase :</td>
                  <td>25/05/2024</td>
                </tr>
                <tr>
                  <td>Total Price</td>
                  <td>${data?.price}</td>
                </tr>
                <tr>
                  <td>Discount ({data?.discount})</td>
                  <td>${discountedAmount}</td>
                </tr>
                <tr>
                  <td>Amount Paid</td>
                  <td>${paidAmount}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <button className="Button" onClick={SaveAsPDFHandler}>
            Download Invoice
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default PurchaseDetailModal;
